import { render, staticRenderFns } from "./CreatedOnText.vue?vue&type=template&id=ac1a78ec&"
import script from "./CreatedOnText.vue?vue&type=script&lang=js&"
export * from "./CreatedOnText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports